/* eslint-disable max-len */
import 'react';

const HomeTagSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="控件" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="标签">
                <path d="M20,0 L20,20 L0,20 L0,0 L20,0 Z" id="Vector"></path>
                <path d="M11.1203449,1.63032564 C11.1704952,1.67155579 11.2165112,1.71757177 11.2577413,1.76772209 L14.9852814,6.30171813 L14.9852814,15.9852814 C14.9852814,16.5375661 14.5375661,16.9852814 13.9852814,16.9852814 L6.98528137,16.9852814 C6.43299662,16.9852814 5.98528137,16.5375661 5.98528137,15.9852814 L5.98528137,6.30171813 L9.71282144,1.76772209 C10.0635573,1.34110424 10.693727,1.27958976 11.1203449,1.63032564 Z M10.4852814,4.52112425 C9.9882251,4.52112425 9.58528137,4.91972377 9.58528137,5.41142119 C9.58528137,5.90311861 9.9882251,6.30171813 10.4852814,6.30171813 C10.9823376,6.30171813 11.3852814,5.90311861 11.3852814,5.41142119 C11.3852814,4.91972377 10.9823376,4.52112425 10.4852814,4.52112425 Z" id="形状结合备份-12" fill="currentColor" transform="translate(10.485281, 9.485281) rotate(-315.000000) translate(-10.485281, -9.485281) "></path>
            </g>
        </g>
    </svg>
);

export default HomeTagSvg;
